import { render, staticRenderFns } from "./extend_pt.vue?vue&type=template&id=bfe725ea&"
import script from "./extend_pt.vue?vue&type=script&lang=js&"
export * from "./extend_pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports